module.exports = __webpack_public_path__ + "img/edit.74292de0.svg";